import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const inferenceServingComponent: ComponentDef = {
  id: 'inference-serving',
  name: 'Inference Serving',
  description: 'Batch incoming requests, route them to the model, and return generated tokens.',
  category: 'optimization',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'batch_size', label: 'Batch size', type: 'number', default: 8, min: 1, max: 128, step: 1 },
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    {
      name: 'variant',
      label: 'Variant',
      type: 'select',
      default: 'engine_arch',
      options: [
        { label: 'Engine Architecture', value: 'engine_arch' },
        { label: 'Request Lifecycle', value: 'request_lifecycle' },
        { label: 'Engine Comparison', value: 'engine_comparison' }
      ]
    }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const batch_size = Number(params.batch_size);
    const seq_len = Number(params.seq_len);
    const variant = String(params.variant);

    const g = new GraphBuilder();

    if (variant === 'request_lifecycle') {
      // Request lifecycle: trace a request from arrival to response
      g.input('request', [seq_len, d_model]);
      g.scale('tokenize', 'request', 'Tokenize');
      g.scale('enqueue', 'tokenize', 'Enqueue');
      g.router('scheduler', 'enqueue', [batch_size, seq_len, d_model]);
      g.scale('prefill', 'scheduler', 'Prefill Phase');
      g.cache('kv_cache', 'prefill', [batch_size, seq_len, d_model]);
      g.scale('decode_loop', 'kv_cache', 'Decode Loop');
      g.scale('detokenize', 'decode_loop', 'Detokenize');
      g.metric('e2e_latency', 'detokenize', 'E2E Latency');
      g.output('out', 'e2e_latency');
    } else if (variant === 'engine_comparison') {
      // Engine comparison: vLLM vs TGI vs Triton side by side
      g.input('workload', [batch_size, seq_len, d_model]);
      g.split('engines', 'workload', [batch_size, seq_len, d_model], '3 engines');
      g.scale('vllm', 'engines', 'vLLM (PagedAttn)');
      g.scale('tgi', 'engines', 'TGI (Continuous)');
      g.scale('triton', 'engines', 'Triton (Inflight)');
      g.concat('results', ['vllm', 'tgi', 'triton'], [3]);
      g.metric('throughput', 'results', 'Tokens/s');
      g.metric('p99_latency', 'throughput', 'P99 Latency');
      g.output('out', 'p99_latency');
    } else {
      // Engine architecture (default): show serving engine internals
      for (let i = 0; i < batch_size; i++) {
        g.input(`req_${i}`, [seq_len, d_model]);
      }
      const inputs = Array.from({ length: batch_size }, (_, i) => `req_${i}`);
      g.concat('batch', inputs, [batch_size, seq_len, d_model]);
      g.router('router', 'batch', [batch_size, seq_len, d_model]);
      g.linear('model', 'router', [d_model, d_model]);
      g.scale('responses', 'model', 'Responses');
      g.output('out', 'responses');
    }

    return g.build();
  }
};
